import { createContext, useContext } from "react";
import { io } from "socket.io-client";
import config from "../config";

// Create a context with an initial value of null
const SocketContext = createContext({ socket: null });

const SocketProvider = ({ children }) => {
  // Initialize your Socket.IO connection here
  const socket = io(config.SUPPORT_SOCKET_URL);

  // Provide the socket value to the context
  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

// Custom hook to access the socket from any component
const useSocket = () => {
  const { socket } = useContext(SocketContext);

  if (!socket) {
    throw new Error("useSocket must be used within a SocketProvider");
  }

  return socket;
};

export { SocketProvider, useSocket };
